import { Children, createElement } from 'react';
import Styles from './HeroTextReveal.module.css';

// Cross-fade a fixed blurred copy into sharp text. Only opacity/transform animate;
// the original heading remains the single accessible, semantic text element.
export default function HeroTextReveal({ children, delay = 0 }) {
    const child = Children.only(children);
    const blurred = createElement('div', {
        className: child.props.className,
        style: { marginBottom: child.type === 'p' ? '1rem' : '0.5rem', lineHeight: child.type === 'p' ? undefined : 1.2 },
    }, child.props.children);
    return <div className={Styles.reveal} style={{ '--reveal-delay': delay + 's' }}>
        <div className={Styles.sharp}>{child}</div>
        <div className={Styles.blur} aria-hidden="true">{blurred}</div>
    </div>;
}
